<template>
  <div class="localStoreRecharge">
    <CopyDesc :title="title" :orderList='orderList' :htmlTag='htmlTag'></CopyDesc>
    <CopyContent></CopyContent>

  </div>
</template>

<script>
export default {
data(){
return{
  title:this.$t('other.a1072'),
    orderList:[{
        label:this.$t('other.a2182'),
        desc:this.$t('other.a2183'),
    },{
        label:this.$t('other.a2184'),
        desc:this.$t('other.a2185'),
    },{
        label:this.$t('other.a2186'),
        desc:this.$t('other.a2187'),
    },],
    htmlTag:'<a href="https://www.yuque.com/dongtiandeyinghuochong/qtw9rm/hm1gkq">'+this.$t('other.a2188')+'</a>'
}
},
components: {
  CopyDesc:() => import(`./components/copyDesc`),
  CopyContent:() => import(`./components/localStoreInfo`),
   

},
create(){

},
methods:{

}
}

</script>
<style scoped>
.localStoreRecharge{

}
</style>